import store from 'store2';
import { useMount } from 'react-use';
import { isEmpty, pickBy } from 'lodash';

import { useSearchQuery } from './useSearchQuery';
import { useExperiments } from './useExperiments';
import { useActions } from './useActions';

const UTM_STORE_KEY = 'utm_signup';

export function useUtmUpdate() {
    const { isSavingUtm } = useExperiments();
    const { api } = useActions();

    useMount(() => {
        const payload = store.get(UTM_STORE_KEY);

        if (!(isSavingUtm && payload)) {
            return;
        }

        store.remove(UTM_STORE_KEY);

        void api.users.updateUtm({ payload });
    });
}

export function useUtmStore() {
    const query = useSearchQuery();

    useMount(() => {
        if (store.get(UTM_STORE_KEY)) {
            return;
        }

        const data = pickBy(query, (_, key) => key.startsWith('utm_') || key.match(/^\w+clk?id$/));

        if (!isEmpty(data)) {
            store.set(UTM_STORE_KEY, data);
        }
    });
}
